import { ConfigParserError } from 'core/config/config-parser';
import { Utils } from 'core/utils';
import { StageConfig } from './stage-config';

export class StageConfigParser
{
  /**
   * @throws ConfigParserError
   */
  public static getConfig(
    genericPart: any, templateId: string): StageConfig
  {
    const genericTemplate = genericPart.templates[templateId];
    StageConfigParser.validateConfig(genericTemplate);

    return <StageConfig> {
      rotation: Utils.optional(genericTemplate, ['rotation'], 0),
      width: Utils.optional(genericPart, ['dimensions', 'width']),
      height: Utils.optional(genericPart, ['dimensions', 'height']),
      svgStructure: genericTemplate.structure,
      svgStructureURL: genericTemplate.structure_url,
    };
  }

  /**
   * @throws ConfigParserError
   */
  private static validateConfig(genericTemplate: any): void
  {
    if (genericTemplate.structure_url === undefined) {
      throw new ConfigParserError('structure url is undefined');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/collage-designer/stage/stage-config-parser.ts